import React from "react";

class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.locationKey !== this.props.locationKey) {
      this.setState({ hasError: false, error: null });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="py-10 px-4 text-center">
          <p className="text-lg font-semibold text-gray-700 dark:text-gray-200">
            Unable to display this page.
          </p>
          <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
            {this.state.error?.message || "An unexpected error occurred."}
          </p>
          <button
            type="button"
            className="mt-4 px-4 py-2 text-sm font-medium text-white bg-orange-500 rounded-md hover:bg-orange-600"
            onClick={() => window.location.reload()}
          >
            Reload
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default RouteErrorBoundary;
